import { Injectable, type Type } from '@angular/core';
import { BasicWidgetCode } from '../../interfaces/TailoredWidget.interface';
import type { AbstractTailoredBasicWidget } from './AbstractTailoredBasicWidget.class';
import { ScaleWidgetComponent } from './scale-widget/scale-widget';

@Injectable({
    providedIn: 'root'
})
export class BasicWidgetClassStaticProvider {
    static getWidgetFromBasicWidgetCode(code: BasicWidgetCode): Type<AbstractTailoredBasicWidget<any>> {
        switch (code) {
            case BasicWidgetCode.SCALE: {
                return ScaleWidgetComponent;
            }
        }
    }
}
